module.exports = __webpack_public_path__ + "img/bsms_6b_dc_cidlo.a26a83e5.webp";